import React, { useState } from 'react';
import clsx from 'clsx';
import moment from 'moment';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/styles';
import {
  Card,
  CardActions,
  CardContent,
  CardHeader,
  Divider,
  Switch,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
} from '@material-ui/core';

const useStyles = makeStyles(theme => ({
  root: {},
  content: {
    padding: 0,
  },
  nodataCont: {
    textAlign: 'center',
    padding: '14px',
    fontSize: '18px',
    color: '#bfbfbf',
    fontWeight: 800,
  },
  commentCell: {
    maxWidth: 360,
    whiteSpace: 'normal',
    wordBreak: 'break-word',
  },
  actions: {
    padding: theme.spacing(0, 1),
    justifyContent: 'flex-end',
  },
}));

const Results = props => {
  const { className, orders, onUpdatestattus, ...rest } = props;
  const classes = useStyles();
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  const toggleChecked = (order) => (e) => {
    if (onUpdatestattus) {
      onUpdatestattus(order, e.target.checked);
    }
  };

  const pagedRows = orders.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);

  return (
    <div {...rest} className={clsx(classes.root, className)}>
      <Card>
        <CardHeader title="User feedback" />
        <Divider />
        <CardContent className={classes.content}>
          <TableContainer>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>S No</TableCell>
                  <TableCell>Username</TableCell>
                  <TableCell>Mobile</TableCell>
                  <TableCell>Rating</TableCell>
                  <TableCell>Comment</TableCell>
                  <TableCell>Created At</TableCell>
                  <TableCell>Active</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {pagedRows.map((order, index) => (
                  <TableRow hover key={order.id}>
                    <TableCell>{page * rowsPerPage + index + 1}</TableCell>
                    <TableCell>{order.name || '—'}</TableCell>
                    <TableCell>{order.mobilenumber || '—'}</TableCell>
                    <TableCell>{order.rating != null ? `${order.rating}/5` : '—'}</TableCell>
                    <TableCell className={classes.commentCell}>{order.comment || '—'}</TableCell>
                    <TableCell>
                      {order.createdAt
                        ? moment(order.createdAt).format('DD/MM/YYYY hh:mm A')
                        : '—'}
                    </TableCell>
                    <TableCell>
                      <Switch
                        checked={!!order.status}
                        onChange={toggleChecked(order)}
                        color="primary"
                        inputProps={{ 'aria-label': 'feedback status' }}
                      />
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
            {orders.length === 0 && (
              <Typography className={classes.nodataCont} component="h6">
                No Records found
              </Typography>
            )}
          </TableContainer>
        </CardContent>
        <CardActions className={classes.actions}>
          <TablePagination
            component="div"
            count={orders.length}
            onChangePage={(event, nextPage) => setPage(nextPage)}
            onChangeRowsPerPage={(event) => {
              setRowsPerPage(parseInt(event.target.value, 10));
              setPage(0);
            }}
            page={page}
            rowsPerPage={rowsPerPage}
            rowsPerPageOptions={[5, 10, 25]}
          />
        </CardActions>
      </Card>
    </div>
  );
};

Results.propTypes = {
  className: PropTypes.string,
  orders: PropTypes.array.isRequired,
  onUpdatestattus: PropTypes.func,
};

Results.defaultProps = {
  orders: [],
};

export default Results;
